import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Sitemap = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Site Map | Green Orange</h1>
                <p className="colorWht">"Site tree" redirects here</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 sitemap">
                <ul>
                  <li>
                    <Link to="/products" title="Products">
                      Products
                    </Link>
                    <ul>
                      <li>
                        <Link to="/transport-management-system" title="Transport Management System">
                          Transport Management System
                        </Link>
                      </li>
                      <li>
                        <Link to="/payroll" title="Payroll Management System">
                          Payroll
                        </Link>
                      </li>
                      <li>
                        <Link to="/gps-tracking-software" title="GPS Tracking as Software">
                          GPS Tracking as Software
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="padT12">
                    <Link to="/services" title="Services">
                      Services
                    </Link>
                    <ul>
                      <li>
                        <Link to="/applications" title="Applications">
                          Applications
                        </Link>
                      </li>
                      <li>
                        <Link to="/enterprise-resource-planning" title="ERP">
                          ERP
                        </Link>
                      </li>
                      <li>
                        <Link to="/consulting" title="Consulting">
                          Consulting
                        </Link>
                      </li>
                      <li>
                        <Link to="/mobility" title="Mobility">
                          Mobility
                        </Link>
                      </li>
                      <li>
                        <Link to="/business-process" title="Business Process">
                          Business Process
                        </Link>
                      </li>
                      <li>
                        <Link to="/gps-tracking-service" title="GPS Tracking as Service">
                          GPS Tracking as Service
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="padT12">
                    <Link to="/about" title="About Us">
                      About Us
                    </Link>
                  </li>
                  <li className="padT12">
                    <Link to="/contact" title="Contact Us">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Sitemap;

